import { Box, Collapse, UnstyledButton } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ResultsClause,
  ResultsClauseHelpContent,
} from './results-clause-help-content';

import classes from './results-clause-help.module.css';

const HELP_EXPANDED_STORAGE_KEY = 'precifield.results.help.expanded';

export interface ResultsClauseHelpProps {
  clause: ResultsClause;
}

export const ResultsClauseHelp: FC<ResultsClauseHelpProps> = ({ clause }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useLocalStorage({
    key: HELP_EXPANDED_STORAGE_KEY,
    defaultValue: false,
  });

  return (
    <Box className={classes.helpSection}>
      <UnstyledButton
        aria-expanded={expanded}
        className={classes.toggle}
        onClick={() => setExpanded((open) => !open)}
        type="button"
      >
        <span className={classes.toggleLabel}>
          {t('sampling.results.help.toggle_label')}
          <span className={classes.clauseBadge}>
            {' '}
            — {t(`clauses.${clause}`)}
          </span>
        </span>
        {expanded ? (
          <IconChevronUp aria-hidden size={16} stroke={1.5} />
        ) : (
          <IconChevronDown aria-hidden size={16} stroke={1.5} />
        )}
      </UnstyledButton>
      <Collapse in={expanded}>
        <Box className={classes.content}>
          <ResultsClauseHelpContent clause={clause} variant="full" />
        </Box>
      </Collapse>
    </Box>
  );
};

